import {
  Component,
  Input,
  SimpleChanges,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { TableRow } from '../table-row.interface';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzTableModule } from 'ng-zorro-antd/table';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FlexModule } from '@angular/flex-layout';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { TooltipComponent } from '../tooltip/tooltip.component';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { MatIconModule } from '@angular/material/icon';
import { EpisodeOfCareService } from 'src/app/services/episodeOfCare.service';
import { Router } from '@angular/router';
import { AllergyService } from 'src/app/services/allergy.service';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NgModule } from '@angular/core';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { VaccinationService } from '../../services/vaccination.service';
import { MedicalAlertService } from '../../services/medicalAlert.service';
import { MedicalHistoryService } from '../../services/medicalHistory.service';
import { IGetList } from 'src/app/interfaces/Get/IGetList';
import { MedicalDeviceService } from '../../services/medicalDevice.service';
import { ProcedureService } from '../../services/procedure.service';
import { CurrentProblemsService } from '../../services/currentProblems.service';
import { ResolvedProblemsService } from '../../services/resolvedProblems.service';
import { PregnancyHistoryService } from 'src/app/services/pregnancyHistory.service';
import { PregnancyOutcomeService } from 'src/app/services/pregnancyOutcome.service';
import { PregnancyStatusService } from 'src/app/services/pregnancyStatus.service';
import { CarePlanService } from '../../services/carePlan.service';
import { SocialHistoryService } from '../../services/socialHistory.service';
import { CurrentMedicationService } from 'src/app/services/currentMedication.service';
import { TravelHistoryService } from '../../services/travelHistory.service';
import { PastMedicationService } from 'src/app/services/pastMedication.service';
import { VitalSignService } from 'src/app/services/vitalSign.service';
import moment from 'moment';
import { IReferenceValue } from 'src/app/interfaces/IReferenceValue';
import { ArterialBloodGasService } from 'src/app/services/arterialBloodGas.service';
import { GlasgowService } from 'src/app/services/glasgow.service';
import { CtParametersService } from 'src/app/services/ctparameters.service';
import { TubeCharacteristicsService } from 'src/app/services/tubeCharacteristics.service';
import { DynamicService } from '../../services/dynamic.service';
import { CapnographyService } from 'src/app/services/capnography.service';
import { InitialAssessmentService } from 'src/app/services/initialAssessment.service';
import { WeightService } from 'src/app/services/weight.service';
import { NeckService } from 'src/app/services/neck.service';
import { PermissionService } from 'src/app/services/permission.service';
import { PermissionModule } from 'src/app/modules/permission.module';
import { SwalToastService } from 'src/app/services/swal.service';
import { date_format, datetime_format } from 'src/date/date.configuration';
import { GlucoseService } from 'src/app/services/glucose.service';
import { NutritionIntakeService } from 'src/app/services/nutritionIntake.service';
import { DietaryHabitsService } from 'src/app/services/dietaryHabits.service';

@Component({
  selector: 'app-reusable-table',
  standalone: true,
  templateUrl: './reusable-table.component.html',
  styleUrls: ['./reusable-table.component.css'],
  imports: [
    NzLayoutModule,
    NzTableModule,
    TranslateModule,
    CommonModule,
    FlexModule,
    NzTooltipModule,
    NzIconModule,
    MatIconModule,
    TooltipComponent,
    NzSwitchModule,
    FormsModule,
    NzButtonModule,
    NzModalModule,
    NzPaginationModule,
    PermissionModule,
  ],
  providers: [NgModule],
})
export class ReusableTableComponent<T extends TableRow> {
  currentPageIndex: number = 1;
  pageSize: number = 10;

  @Input() noKnownComponent: Type<any> | null = null;
  @Input() addComponent: Type<any> | null = null;
  @Input() expandComponent?: any;

  @Input() isLoading?: boolean = false;
  @Input() isNoKnownLoading?: boolean;
  @Input() pagination?: boolean = true;

  @Input() isStopped?: boolean = false;

  @Input() title: string = '';
  @Input() columns: string[] = [];
  @Input() rowFields: string[] = [];
  @Input() data?: T[];
  @Input() dataGetList?: IGetList<T>;

  @Input() refValues?: IReferenceValue[];

  @Input() isPreview?: boolean;

  @Input() deleteFun?: Function;
  @Input() openModalFun?: Function;
  @Input() handleToggleFun?: Function;
  @Input() stopFun?: Function;
  @Input() revertStopFun?: Function;

  @Input() groupId?: number;

  @Input() addPermissions: string[] = [];
  @Input() stopPermissions: string[] = [];

  @ViewChild('expandContainer', { read: ViewContainerRef, static: false })
  expandCont!: ViewContainerRef;

  filteredData: T[] = [];

  // DO NOT REMOVE ALLERGY, VACCINATION,... SERVICES!!!
  constructor(
    private readonly eocService: EpisodeOfCareService,
    private readonly router: Router,
    private readonly allergyService: AllergyService,
    private readonly vaccinationService: VaccinationService,
    private readonly medicalAlertService: MedicalAlertService,
    private readonly medicalHistoryService: MedicalHistoryService,
    private readonly procedureService: ProcedureService,
    private readonly medicalDeviceService: MedicalDeviceService,
    private readonly currentProblemsService: CurrentProblemsService,
    private readonly resolvedProblemsService: ResolvedProblemsService,
    private readonly pregnancyHistoryService: PregnancyHistoryService,
    private readonly pregnancyOutcomeService: PregnancyOutcomeService,
    private readonly pregnancyStatusService: PregnancyStatusService,
    private readonly carePlanService: CarePlanService,
    private readonly socialHistoryService: SocialHistoryService,
    private readonly initialAssessmentService: InitialAssessmentService,
    private readonly travelHistoryService: TravelHistoryService,
    private readonly currentMedicationService: CurrentMedicationService,
    private readonly pastMedicationService: PastMedicationService,
    private readonly dynamicService: DynamicService,
    private readonly vitalSignService: VitalSignService,
    private readonly arterialBloodGasService: ArterialBloodGasService,
    private readonly glasgowService: GlasgowService,
    private readonly ctParametersService: CtParametersService,
    private readonly tubeCharacteristicsService: TubeCharacteristicsService,
    private readonly capnographyService: CapnographyService,
    private readonly weightService: WeightService,
    private readonly neckService: NeckService,
    private readonly translate: TranslateService,
    private readonly swalToastService: SwalToastService,
    private readonly glucoseService: GlucoseService,
    private readonly nutritionIntakeService: NutritionIntakeService,
    private readonly permissionService: PermissionService,
    private readonly dietaryHabitsService: DietaryHabitsService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.getData();
    }
  }

  hasPermission(permission: string[]): boolean {
    return this.permissionService.can(permission);
  }

  handleToggle() {
    this.handleToggleFun?.(
      this.isPreview,
      !this.dataGetList?.noKnown,
      this.dataGetList?.getUnknown?.id?.toString()!
    );
  }

  getData() {
    if (this.data?.length! > 0) {
      if (this.pagination) {
        const startIndex = (this.currentPageIndex - 1) * this.pageSize;
        const endIndex = startIndex + this.pageSize;
        this.filteredData = this?.data?.slice(startIndex, endIndex) || [];
      } else {
        this.filteredData = this?.data || [];
      }
    } else {
      this.filteredData = [];
    }
  }

  handlePageIndexChange(pageIndex: number): void {
    this.currentPageIndex = pageIndex;
    this.getData();
  }

  handlePageSizeChange(pageSize: number): void {
    this.pageSize = pageSize;
    this.currentPageIndex = 1; // Reset to the first page when changing page size

    this.getData();
  }

  expandSet: Set<number> = new Set<number>();

  getUnknownText(): string {
    if (this.dataGetList?.noInfo || this.dataGetList?.noKnown) {
      for (const key in this.dataGetList?.getUnknown) {
        if (key !== 'id') {
          return this.dataGetList?.getUnknown[key];
        }
      }
    }

    return 'No data available';
  }

  openModal(item?: T) {
    this?.openModalFun?.(item);
  }

  showActions() {
    return (
      (this.filteredData?.find(
        (d) => d?.['isSubmitted'] !== undefined && !d?.['isSubmitted']
      ) ||
        this.stopFun) &&
      !this.isPreview &&
      (this.isEOC() || this.isInpatientView())
    );
  }

  onExpandChange(id: number): void {
    if (this.expandSet) {
      if (!this.expandSet.has(id)) {
        this.expandSet.add(id);
      } else {
        this.expandSet.delete(id);
      }
    }
  }

  expandAll():void {
    if (!this.expandComponent) return;
    const target = this.pagination ? this.filteredData : (this.data || []);
    target.forEach(item => {
      const id = (item as any)?.id as number;
      if (id !== undefined && id !== null) this.expandSet.add(id);
    });
  }

  collapseAll():void {
    if (!this.expandComponent) return;
    const target = this.pagination ? this.filteredData : (this.data || []);
    target.forEach(item => {
      const id = (item as any)?.id as number;
      if (id !== undefined && id !== null) this.expandSet.delete(id);
    });
  }

  toggleExpandAll(): void {
    const target = this.pagination ? this.filteredData : (this.data || []);
    const anyCollapsed = target.some(item => !this.expandSet.has((item as any)?.id));
    if (anyCollapsed) this.expandAll(); else this.collapseAll();
  }

  isAllVisibleExpanded(): boolean {
    const target = this.pagination ? this.filteredData : (this.data || []);
    if (!target?.length) return false;

    return target.every(item => this.expandSet.has((item as any)?.id));
  }
  isEOC() {
    return (
      !(
        this.eocService.currentEocId() === null ||
        this.eocService.currentEocId() === ''
      ) && this.router.url.includes('episodeOfCare')
    );
  }

  isInpatientView() {
    return (
      !(
        this.eocService.currentEocId() === null ||
        this.eocService.currentEocId() === ''
      ) && this.router.url.includes('inPatientView')
    );
  }

  getValue(field: string, value?: any) {
    if (value === null || value === undefined) {
      return '-';
    }

    if (field?.toLowerCase()?.includes('datetime')) {
      return moment(value).format(datetime_format);
    } else if (
      field?.toLowerCase()?.includes('date') ||
      field?.toLowerCase()?.includes('onset') ||
      field?.toLowerCase()?.includes('effectivelow') ||
      field?.toLowerCase()?.includes('effectivehigh')
    ) {
      return moment(value).format(date_format);
    } else {
      return value?.toString() || value;
    }
  }

  checkReference(value: any, refValue?: IReferenceValue): boolean {
    if (typeof value == 'number' && refValue) {
      if (value < refValue?.min! || value > refValue?.max!) {
        return true;
      }
    }
    return false;
  }

  checkRV(value: any, refValue?: IReferenceValue): string {
    if (typeof value == 'number' && refValue) {
      if (!refValue?.mid) {
        if (value < refValue?.min! || value > refValue?.max!) {
          return 'red';
        }
      } else {
        if (value > refValue?.max!) {
          return 'red';
        } else if (value > refValue?.mid!) {
          return 'orange';
        }
      }
    }
    return '';
  }

  isItemStopped(isItemStopped: boolean) {
    if (this.isStopped) {
      if (isItemStopped) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  }
}
